"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:7.3.0'] && _();
}
catch (e) { }
